import NewsOrEvent from './NewsOrEvent'

export default NewsOrEvent
